import { render, staticRenderFns } from "./tabs.vue?vue&type=template&id=1d95fc94&scoped=true&lang=pug&"
import script from "./tabs.vue?vue&type=script&setup=true&lang=js&"
export * from "./tabs.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./tabs.vue?vue&type=style&index=0&id=1d95fc94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d95fc94",
  null
  
)

export default component.exports